import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { getTenantConfig } from './tenant-config'

const tenant = getTenantConfig()

const supabaseUrl = tenant.supabase.url
const supabaseAnonKey = tenant.supabase.anon_key

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(`Missing Supabase credentials for tenant "${tenant.slug}"`)
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
